/* eslint-disable react/react-in-jsx-scope */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import Tooltip from '@atlaskit/tooltip';
// AFP-2532 TODO: Fix automatic suppressions below
// https://product-fabric.atlassian.net/browse/AFP-2532
// eslint-disable-next-line @atlassian/tangerine/import/entry-points
import { colors } from '@atlaskit/theme';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import moment, { type Moment } from 'moment-timezone';
import { type PeriodProps } from '../../../../../common/types';
import {
	localMidnight,
	normalizeDate,
	adjustLabelToFit,
	generateTooltipLabel,
} from '../../../../../common/utils';
import { HistoricalMarker } from './styled';
import { token } from '@atlaskit/tokens';

export function Period({
	startDate: periodStartDate,
	endDate: periodEndDate,
	rotation: { startDate: rotationStartDate, days: rotationDays, timezone },
	backgroundColor = token('color.background.neutral.bold', colors.N500),
	textColor = token('color.text.inverse', colors.N0),
	label,
	type,
}: PeriodProps) {
	const localRotationStartDate: Moment = localMidnight(rotationStartDate, timezone);
	const rotationStartDateMillis: number = normalizeDate(localRotationStartDate, timezone).valueOf();
	const rotationEndDateMillis: number = normalizeDate(
		moment.tz(localRotationStartDate, timezone).add(rotationDays, 'days'),
		timezone,
	).valueOf();

	const periodStartDateMillis: number = normalizeDate(periodStartDate, timezone).valueOf();
	const periodEndDateMillis: number = normalizeDate(periodEndDate, timezone).valueOf();

	const totalDuration: number = moment.duration(rotationDays, 'days').asMilliseconds();

	const begin = Math.max(rotationStartDateMillis, periodStartDateMillis) - rotationStartDateMillis;
	const end = Math.min(rotationEndDateMillis, periodEndDateMillis) - rotationStartDateMillis;
	const duration = end - begin;
	const width = (duration / totalDuration) * 100;
	return (
		<li
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className="period"
			// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
			css={css({
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
				color: textColor,
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
				backgroundColor: backgroundColor,
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
				width: `${width}%`,
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
				left: `${(begin / totalDuration) * 100}%`,
			})}
		>
			<Tooltip content={generateTooltipLabel(label)} position="top">
				<div>{adjustLabelToFit(label, width)}</div>
			</Tooltip>
			{type === 'historical' ? <HistoricalMarker /> : null}
		</li>
	);
}

export default Period;
